import HeaderPage from "../../../components/lines-managements/header/HeaderPage";
import Table, { Row } from "../../../components/ui/table";
import Pagination from "../../../components/ui/table/Pagination";
import { useSearch } from "../../../hooks/useSearch";
import { IGTFSEnrollmentLog } from "../../../interfaces/endpoints/IGTFS.types";
import { getEnrollmentLog } from "../../../services/GTFS.service";

const COLUMNS = [
  "ID",
  "Action",
  "Entity Type",
  "Entity ID",
  "Details",
  "Processed At"
];

const PAGE_SIZE = 20;

const ACTION_STYLES: Record<string, string> = {
  CREATE: "bg-green-100 text-green-800",
  ADD_TRIPS: "bg-blue-100 text-blue-800",
  REMOVE_TRIPS: "bg-orange-100 text-orange-800",
  SKIP: "bg-gray-100 text-gray-800",
  ERROR: "bg-red-100 text-red-800"
};

const GTFSEnrollmentLog: React.FC = () => {
  const { response, loading, handlePageChange, page } = useSearch(getEnrollmentLog, {
    otherQuery: { pageSize: String(PAGE_SIZE) }
  });

  return (
    <>
      <HeaderPage />
      <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
        <Table titles={COLUMNS} style="hover" loading={loading}>
          {!loading && response?.data?.result?.length ? (
            response.data.result.map((row: IGTFSEnrollmentLog) => (
              <Row
                key={row.id}
                id={row.id}
                action={
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      ACTION_STYLES[row.action] || "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {row.action}
                  </span>
                }
                entityType={row.entityType}
                entityId={row.entityId}
                details={
                  <span className="block max-w-md truncate" title={row.details}>
                    {row.details}
                  </span>
                }
                processedAt={new Date(row.processedAt).toLocaleString()}
              />
            ))
          ) : (
            <tr>
              <td colSpan={COLUMNS.length} className="text-center py-4">
                {loading ? "Loading..." : "No enrollment logs found"}
              </td>
            </tr>
          )}
        </Table>
        <Pagination
          onPageChange={handlePageChange}
          totalCount={response?.data?.totalCount || 0}
          length={response?.data?.result?.length || 0}
          page={page}
          pageSize={PAGE_SIZE}
        />
      </div>
    </>
  );
};

export default GTFSEnrollmentLog;
